if (!customElements.get('vault-banner')) {
  customElements.define('vault-banner', class VaultBanner extends HTMLElement {
    constructor() {
      super();
      this.templateId = 'vault-info';
    }

    connectedCallback() {
      this.defineElements();
      this.addListeners();
    }

    defineElements() {
      this.$klaviyoButton = this.querySelector('.vault-banner__button');
      this.$buttonOpenDrawer = this.querySelector('a[href="#open-vault-info"]');

    }
 
    addListeners() {
      this.$klaviyoButton?.addEventListener('click', this.triggerKlaviyo.bind(this));
      this.$buttonOpenDrawer?.addEventListener('click', this.openInfoDrawer.bind(this));
    }

    openInfoDrawer(event) {
      event.preventDefault();
      if (!this.templateId) return;

      window.dispatchEvent(new CustomEvent("customDrawerOpen", {
        detail:
          {
            templateId: this.templateId
          },
      }),
    );
    }

    triggerKlaviyo(event) {
      const id = event.target.closest('button')?.getAttribute('data-klaviyo-form') || null;

      if (id) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', id]);
      }
    }
  });
}